module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchPage"
  }, [_c('topNav', {
    ref: "topnav",
    attrs: {
      "title": _vm.isMultSelect ? _vm.mutlSelectTitle : _vm.search_title,
      "selectMore": true,
      "operateTextConfirm": "determine"
    },
    on: {
      "goSelect": _vm.goSelect,
      "operateMultSelected": _vm.operateMultSelected,
      "cancleSelectMore": _vm.cancleSelectMore
    }
  }), _vm._v(" "), _c('searchHotel', {
    attrs: {
      "isMultSelect": _vm.isMultSelect,
      "allowSelectOpera": true,
      "from": "pageHeader"
    },
    on: {
      "selectMultItem": _vm.selectMultItem,
      "selectHotel": _vm.setHotel,
      "setHotelLcg": _vm.setHotelLcg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-30767883","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/search.vue
// module id = 1762
// module chunks = 107